// extracted by mini-css-extract-plugin
export default {"simpleButton":"ControlButtons_simpleButton__Fx895","trackControlButtons":"ControlButtons_trackControlButtons__hCVmt","isPlaying":"ControlButtons_isPlaying__8UFLG"};